import { FC, Fragment, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { t } from "i18next";

import { InputWithCornerHint } from "../atoms/InputWithCornerHint";
import { useDebounce } from "@/shared/hooks/debounce";

export type ListCartProps = {
  cart: any;
  onAmountChange: any;
  onPriceChange: any;
  onDelete: any;
};

export const ListCart: FC<ListCartProps> = ({
  cart,
  onAmountChange,
  onPriceChange,
  onDelete,
}) => {
  const [amount, setAmount] = useState(cart.amount);
  const [price, setPrice] = useState(cart.price);
  const debouncedAmount = useDebounce(amount, 200);
  const debouncedPrice = useDebounce(price, 200);

  useEffect(() => {
    if (debouncedAmount == cart.amount) return;
    onAmountChange(cart, debouncedAmount);
  }, [debouncedAmount]);

  useEffect(() => {
    if (debouncedPrice == cart.price) return;
    onPriceChange(cart, debouncedPrice);
  }, [debouncedPrice]);

  return (
    <Fragment>
      <li key={cart.id} className="flex px-4 py-6 sm:px-6">
        <div className="flex-shrink-0">
          <img
            alt={cart.product.name}
            src={cart.product.img}
            className={"w-20 rounded-md"}
          />
        </div>
        <div className="ml-6 flex flex-1 flex-col">
          <div className="flex">
            <div className="min-w-0 flex-1">
              <h4 className="text-sm">
                <a className="font-medium text-gray-700 hover:text-gray-800">
                  {cart.product.name}
                </a>
              </h4>
              <p className="mt-1 text-sm text-gray-500">
                {cart.product.description}
              </p>
            </div>

            <div className="ml-4 flow-root flex-shrink-0">
              <button
                type="button"
                className="-m-2.5 flex items-center justify-center bg-white p-2.5 text-gray-400 hover:text-gray-500"
                onClick={() => onDelete(cart)}
              >
                <span className="sr-only">Delete</span>
                <FontAwesomeIcon
                  icon={faTrashCan}
                  className="text-red-600 hover:text-red-900"
                />
              </button>
            </div>
          </div>

          <div className="flex flex-1 items-end justify-between pt-2">
            <div className="ml-4">
              <InputWithCornerHint
                label={t("store.views.form.price")}
                type="number"
                max={cart.product.price}
                min={1}
                value={price}
                className="w-32" // Ancho fijo de 8rem (128px)
                onChange={(event) =>
                  parseInt(event.target.value) > 0 &&
                  setPrice(event.target.value)
                }
              />
            </div>

            <div className="ml-4">
              <InputWithCornerHint
                label={t("store.views.form.amount")}
                type="number"
                max={cart.product.amount}
                min={1}
                value={amount}
                className="w-32" // Ancho fijo de 8rem (128px)
                onChange={(event) =>
                  parseInt(event.target.value) > 0 &&
                  setAmount(event.target.value)
                }
              />
            </div>
          </div>
        </div>
      </li>
    </Fragment>
  );
};
